const BRAND_NAME = "QC Home and Business Project Pro's";
// Crest lockups per the Brand & Style Guide (Aug 2026):
// compact (B) for short wide spaces, stacked (A) for marketing/pre-auth,
// badge (C) for placements below 120px wide.
const COMPACT_LOCKUP = "/brand/qc-crest-compact-ink.png";
const STACKED_LOCKUP = "/brand/qc-crest-stacked-ink.png";
const BADGE_LOCKUP = "/brand/qc-crest-badge-ink.png";

/** Approved compact crest. The guide's screen minimum for full lockups is 120px wide. */
export function Wordmark({ className = "h-auto w-[200px]" }: { className?: string }) {
  return (
    <img src={COMPACT_LOCKUP} className={className} width="200" height="69" alt={BRAND_NAME} />
  );
}

/** Approved stacked crest for marketing and pre-auth screens. */
export function BrandLockup({ className = "h-auto w-[240px]" }: { className?: string }) {
  return (
    <img src={STACKED_LOCKUP} className={className} width="240" height="118" alt={BRAND_NAME} />
  );
}

/** Badge lockup for compact placements below 120px of available width. */
export function BrandMark({ className = "h-10 w-auto" }: { className?: string }) {
  return (
    <img
      src={BADGE_LOCKUP}
      className={className}
      width="127"
      height="40"
      alt={`${BRAND_NAME} badge`}
    />
  );
}
